/// <amd-module name="Release/Landing/HubContent/Releases/ViewOptionsSetting" />
import { format } from "VSS/Core/Util/String";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { IVssPageContext } from "VSS/Platform/Context";

import { getTFSPageData } from "Tfs/Platform/Page";

const AllReleasesViewActionSettingFormat = "releases/activeDefinitions/{0}--{1}--viewAllReleases"; // {0} should be project id and {1} should be the release definition id
const ColumnOptionsViewActionSettingFormat = "releases/activeDefinitions/{0}--{1}--visibleColumnOptions"; // {0} should be project id and {1} should be the release definition id

const allReleasesSettingString = (pageContext: IVssPageContext, definitionId: number) => format(
    AllReleasesViewActionSettingFormat,
    getProjectId(pageContext),
    definitionId);

const columnOptionsSettingString = (pageContext: IVssPageContext, itemKey: number | string) => format(
    ColumnOptionsViewActionSettingFormat,
    getProjectId(pageContext),
    itemKey.toString().replace(/\\/g, "$").replace(/[\s]+/g, "$$$")); // folder path cannot have $, but registry settings allow it.

const getProjectId = (pageContext: IVssPageContext) => {
    const tfsPageData = getTFSPageData(pageContext);
    if (tfsPageData && tfsPageData.project) {
        return tfsPageData.project.id;
    }

    return "";
};

export class ShowAllReleasesSetting {
    public static getValue(pageContext: IVssPageContext, definitionId: number): boolean | undefined {
        if (this._settingsCache[definitionId] === undefined) {
            this._settingsCache[definitionId] = pageContext.getService<ISettingsService>("ISettingsService").getEntry<boolean | undefined>(allReleasesSettingString(pageContext, definitionId), SettingsUserScope.Me);
        }

        return this._settingsCache[definitionId];
    }

    public static setValue(pageContext: IVssPageContext, definitionId: number, value: boolean): void {
        pageContext.getService<ISettingsService>("ISettingsService").setEntries({ [allReleasesSettingString(pageContext, definitionId)]: value }, SettingsUserScope.Me);
        this._settingsCache[definitionId] = value;
    }

    private static _settingsCache: { [key: string]: boolean | undefined } = {};
}

export class ColumnViewOptionsSetting {
    public static getValue(pageContext: IVssPageContext, itemKey: number | string): string[] | undefined {
        if (this._columnOptionsMap[itemKey] === undefined) {
            this._columnOptionsMap[itemKey] = pageContext.getService<ISettingsService>("ISettingsService").getEntry<string[] | undefined>(columnOptionsSettingString(pageContext, itemKey), SettingsUserScope.Me);
        }

        return this._columnOptionsMap[itemKey];
    }

    public static setValue(pageContext: IVssPageContext, itemKey: number | string, value: string[]): void {
        pageContext.getService<ISettingsService>("ISettingsService").setEntries({ [columnOptionsSettingString(pageContext, itemKey)]: value }, SettingsUserScope.Me);
        this._columnOptionsMap[itemKey] = value;
    }


    private static _columnOptionsMap: { [key: string]: string[] | undefined } = {}; // Map between definitionId and visible columnKeys for optional columns(description and tags)
}
